// import React, { useState, useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// interface ImageCarouselProps {
//   images: string[];
//   itemsPerPage?: number;
//   className?: string;
// }

// export default function ImageCarousel({
//   images,
//   itemsPerPage = 8,
//   className = "",
// }: ImageCarouselProps) {
//   const [index, setIndex] = useState(0);

//   const maxIndex = Math.max(0, images.length - itemsPerPage);
//   const visible = images.slice(index, index + itemsPerPage);

//   // AUTO SCROLL EVERY 1 SECOND
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIndex((prev) => {
//         if (prev >= maxIndex) return 0; // loop back
//         return prev + 1;
//       });
//     }, 1500);

//     return () => clearInterval(interval);
//   }, [maxIndex]);

//   return (
//     <div className={`flex items-center relative ${className}`}>
//       {/* Left Arrow */}
//       {images.length > itemsPerPage && (
//         <button
//           onClick={() => setIndex((i) => Math.max(0, i - 1))}
//           disabled={index === 0}
//           className={`p-1 mr-4 transition-opacity rounded-full ${
//             index === 0 ? "opacity-0 cursor-default" : "opacity-100"
//           }`}
//         >
//           <ChevronLeft className="w-10 h-10" />
//         </button>
//       )}

//       {/* Images */}
//       <div
//         className="grid gap-2 flex-1 place-items-center"
//         style={{ gridTemplateColumns: `repeat(${itemsPerPage}, 1fr)` }}
//       >
//         {visible.map((src, i) => (
//           <img key={i} src={src} className="w-full h-full object-contain" />
//         ))}
//       </div>

//       {/* Right Arrow */}
//       {images.length > itemsPerPage && (
//         <button
//           onClick={() => setIndex((i) => Math.min(maxIndex, i + 1))}
//           disabled={index >= maxIndex}
//           className={`p-1 ml-4 transition-opacity rounded-full ${
//             index >= maxIndex ? "opacity-0 cursor-default" : "opacity-100"
//           }`}
//         >
//           <ChevronRight className="w-10 h-10" />
//         </button>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useRef, useState } from "react";

interface ImageCarouselProps {
  images: string[];
  itemsPerPage?: number;
  className?: string;
}

export default function ImageCarousel({
  images,
  itemsPerPage = 8,
  className = "",
}: ImageCarouselProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);

  const loopImages = [...images, ...images]; // duplicate for infinite

  // Item width in pixels
  const itemWidth = 128; // parent max-w=1024 / 8 items

  useEffect(() => {
    const speed = 0.5; // pixels per tick, smaller = slower
    const interval = setInterval(() => {
      setOffset((prev) => {
        const totalWidth = images.length * itemWidth;
        const next = prev + speed;
        if (next >= totalWidth) return 0; // loop back
        return next;
      });
    }, 20);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      ref={containerRef}
      className={`relative overflow-hidden w-full max-w-[1024px] ${className}`}
    >
      <div
        ref={trackRef}
        className="flex gap-4"
        style={{
          transform: `translateX(-${offset}px)`,
          transition: "transform 0.02s linear",
        }}
      >
        {loopImages.map((src, i) => (
          <div
            key={i}
            className="flex-shrink-0 flex justify-center items-center"
            style={{ width: `${itemWidth}px` }}
          >
            <img src={src} className="h-20 object-contain" />
          </div>
        ))}
      </div>
    </div>
  );
}
